import React from 'react';
import { Trans } from '@lingui/react/macro';
import { ItemCategory, LocalizedEnum } from '@/types';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import theme from './ProjectMemberPermissionsList.module.scss';
import CheckboxTableCell from '@/components/generic-controls/CheckboxTableCell';
import { intersection } from 'lodash-es';
import { useLingui } from '@lingui/react';

const PermissionsMatrixView = ({ member, permissions, ...rest }) => {
    const { _ } = useLingui();

    const categories = useSelector((state: IState) => state.global.itemCategories);

    const isChecked = (category: ItemCategory, permission: LocalizedEnum) => {
        return !!(member?.categoryPermissions || []).find(
            (x) => x.categoryId === category.id && x.permission === permission.value
        );
    };
    const areAllCategoriesChecked = (permission: LocalizedEnum) => {
        return (
            intersection(
                member?.categoryPermissions.filter((x) => x.permission === permission.value).map((x) => x.categoryId),
                categories.map((x) => x.id)
            ).length === categories.length
        );
    };
    const areAllPermissionsChecked = (category: ItemCategory) => {
        return (
            intersection(
                member?.categoryPermissions.filter((x) => x.categoryId === category.id).map((x) => x.permission),
                permissions!.map((x) => x.value)
            ).length === permissions!.length
        );
    };

    return (
        <div className={theme.row}>
            <div className={theme.full}>
                <h4>
                    <Trans>Profession permissions</Trans>
                </h4>
                <table className={theme.matrix}>
                    <thead>
                        <tr>
                            <td />
                            {categories.map((category) => (
                                <th key={category.id}>
                                    <div>
                                        <span>{category.name}</span>
                                    </div>
                                </th>
                            ))}
                            <th>
                                <div>
                                    <span>
                                        <Trans>All</Trans>
                                    </span>
                                </div>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {permissions.map((permission) => (
                            <tr key={permission.value}>
                                <th>{_({ id: permission.textKey })}</th>
                                {categories.map((category) => (
                                    <CheckboxTableCell
                                        key={category.id}
                                        checked={isChecked(category, permission)}
                                        readOnly
                                        checkboxClassName={theme.cellCheckbox}
                                    />
                                ))}

                                <CheckboxTableCell
                                    checked={areAllCategoriesChecked(permission)}
                                    readOnly
                                    checkboxClassName={theme.cellCheckbox}
                                />
                            </tr>
                        ))}
                        <tr>
                            <th>
                                <Trans>All</Trans>
                            </th>
                            {categories.map((category) => (
                                <CheckboxTableCell
                                    key={category.id}
                                    checked={areAllPermissionsChecked(category)}
                                    readOnly
                                    checkboxClassName={theme.cellCheckbox}
                                />
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PermissionsMatrixView;
